import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useRef, useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import {showmodal,ajout,addOne} from './vendeurSlice';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import axios from 'axios';
import { FormControlLabel, FormGroup, LinearProgress, Stack, Switch } from '@mui/material';



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function Ajouter() {


    const userData = useSelector(state => state.userData);
    const id = userData.id;
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;
    const VendeursData = useSelector(state => state.vendeursData);
    const showModal = VendeursData.modalShow;
    const ListCamion = VendeursData.listCamions;

    const navigate = useNavigate();
    const [checked, setChecked] = useState(true);
    
    const [chargement,setChargement] = useState(false);
    const dispatch= useDispatch();

    const theme = useTheme();
    const [personName, setPersonName] = useState([]);
    const [Listsecteurs, setListsecteurs] = useState([]);
    const [valCamions, setvalCamions] = useState('');

    const handleCheckChange = (event) => {
      setChecked(event.target.checked);
    };
  
    const handleCamionsChange = (event) => {
        setvalCamions(event.target.value);
        };

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      setPersonName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
    };

    const designationField = useRef('')
    const telField = useRef('')
    const secteursField = useRef('')

    const listSecteursBrut = useRef([])


      const handleClose = () => {
        dispatch(showmodal(false));
      };

      const getSecteur=async () => {
        setPersonName([])
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}secteurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        listSecteursBrut.current = response.data
        setListsecteurs(response.data.map(item => item.designation))
        }
     catch (error) {
      navigate('/');    
    }
    setChargement(false);
    }
      const Ajouter =async()=>{
        const nom =designationField.current.value.trim()
        const tel =telField.current.value.trim()
        if(nom==="" || tel==="" | valCamions===""){
            alert("Veuillez remplir les champs manquants");
            return
        }

        let valeur = ListCamion.find(cat => cat._id === valCamions);
        const camion = {
          id: valeur._id,
          designation: valeur.designation
        };

        const tempSecteurs = secteursField.current.value

        const secteurs = tempSecteurs.map(designation => {
          const match = listSecteursBrut.current.find(item => item.designation === designation);
          if (match) {
            return {
              id: match._id,
              designation: match.designation
            };
          }
          return null;
        }).filter(item => item !== null);
        setChargement(true)
        const salaire = 0
        const forceTotp = checked ? "Oui" : "Non";
        const type = 'vendeur'
        const totp = ""
        const apiUrl = process.env.REACT_APP_API_URL;
        const id = userData.id;
        const apitoken = userData.apitoken;
        try {
            const response = await axios.post(`${apiUrl}new/user/${id}/${apitoken}`,
                {
                    nom,
                    tel,
                    camion,
                    type,
                    salaire,
                    totp,
                    forceTotp,
                    secteurs
                },
                {
                    timeout: 20000,
                  }
            );
            if(response.data.status==="ok")
                {
                    const _id=response.data.id;
                    const data={_id,nom,tel,camion,type,salaire,forceTotp,secteurs};
                    dispatch(showmodal(false));
                    dispatch(ajout(true));
                    dispatch(addOne(data));
                    
                }
            else if(response.data.status==="exist")
             {
                alert("Vendeur déja existant");
            }
            setChargement(false)
      }
      catch (error){
        navigate('/');
      }
    }

    useEffect(() =>{
      getSecteur();
      },[showModal]);

  return (
<Dialog
        open={showModal}
        onClose={handleClose}
      >
{ chargement ?
    <Box >
<Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="success" />
    </Stack>
    </Box>
            :
            ''
            }
        <DialogTitle>Ajouter un Vendeur</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Veuillez remplir la fiche du nouveau vendeur
          </DialogContentText>
          <Box mt={2}>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="designation"
            label="Désignation"
            type="text"
            fullWidth
            variant="outlined"
            inputRef={designationField}
          />
          </Box>
          <Box mt={2}>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="tel"
            label="N° Tel."
            type="text"
            fullWidth
            variant="outlined"
            inputRef={telField}
          />
          </Box>


                  <Box mt={2}>
          <FormControl fullWidth required>
          <InputLabel id="demo-simple-select-label">Camion</InputLabel>
          <Select
          fullWidth
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCamions}
          label="Camions"
          onChange={handleCamionsChange}
        >
          {ListCamion.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
          </Box>

          <Box mt={2}>
          <FormControl fullWidth>
        <InputLabel id="demo-multiple-chip-label">Secteurs</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={personName}
          onChange={handleChange}
          inputRef={secteursField}
          input={<OutlinedInput id="select-multiple-chip" label="Secteurs" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {Listsecteurs?.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
          </Box>
          <Box mt={2} display="flex" fullWidth alignItems="left" justifyContent="left">
          <FormGroup>
          <FormControlLabel labelPlacement="start" control={<Switch checked={checked} onChange={handleCheckChange} />} label="Protection 2FA" />
          </FormGroup>
          </Box>
        </DialogContent>
        <DialogActions>
            {chargement ?
            <>
          <Button disabled color="error" onClick={handleClose}>Annuler</Button>
          <Button disabled color="success" onClick={Ajouter}>Enregistrer</Button>
          </>
            :
            <>
          <Button color="error" onClick={handleClose}>Annuler</Button>
          <Button color="success" onClick={Ajouter}>Enregistrer</Button>
          </>
        }
        </DialogActions>
      </Dialog>
  )
}